<!-- Zweck: Stellt die HTML-Struktur für app validate ip component im Frontend bereit. -->
<div class="logincontentinner">
  <div>
    <div class="loginlogobox">
      <img class="logo" src="{{domaincfg.logofilename}}"/>
    </div>


    <div class="loginbox">
      <div class="bar">Neue IP freischalten</div>

      @if (token && ip) {
        <div>
          @if (!(message|async)) {
            <div>
              <h3>Wollten Sie die IP freischalten?</h3>
              <strong>{{ip}}</strong>
              <br>
                <br>
                  <button [disabled]="loading|async" class="btn btn-primary" mat-flat-button (click)="validate()">
                    <svg-icon>success</svg-icon>
                    Freischalten
                  </button>
                  <br>
                    <br>
                    </div>
                  }
                  @if (message|async) {
                    <div>
                      <h3>{{message|async}}</h3>
                      <button [disabled]="loading|async" class="btn btn-primary" mat-flat-button routerLink="/login">
                        <svg-icon>login</svg-icon>
                        Anmelden
                      </button>
                    </div>
                  }
                </div>
              }
              <br>

                <button [disabled]="loading|async" class="btn btn-primary" color="accent" mat-raised-button routerLink="/login">
                  <svg-icon>zurueck</svg-icon>
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
